/* SEVENTYSEVEN.DC — motion + shopping layer (2026-09)
   Loading bar, scroll reveal, card tilt, stamped badges, counters,
   fly-to-bag + sticker toast, saved items, quick view, floating WhatsApp.
   Everything here is progressive: with JS off the page is complete. */
(function(){
  'use strict';
  var CFG = window.SD77CFG || {};
  var RM = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var FINE = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var root = document.documentElement;
  var M = window.SD77 = window.SD77 || {};

  function esc(s){
    return String(s == null ? '' : s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;').replace(/'/g,'&#39;');
  }
  function money(c){ return Math.round(c/100).toLocaleString('en-US') + ' EGP'; }
  function sized(url, w){
    if(!url) return '';
    if(url.indexOf('//') === 0) url = 'https:' + url;
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  function ls(k, v){
    try{
      if(v === undefined) return JSON.parse(localStorage.getItem(k) || 'null');
      localStorage.setItem(k, JSON.stringify(v));
    }catch(e){ return null; }
  }
  function productJS(handle){
    return fetch('/products/' + encodeURIComponent(handle) + '.js', { headers: { Accept: 'application/json' } })
      .then(function(r){ return r.ok ? r.json() : null; }).catch(function(){ return null; });
  }

  /* ── 1. SPRAY LOADING BAR ───────────────────────────── */
  var bar = document.createElement('div');
  bar.className = 'sd-loadbar';
  bar.setAttribute('aria-hidden', 'true');
  document.body.appendChild(bar);
  document.addEventListener('click', function(e){
    if(e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = e.target.closest && e.target.closest('a[href]');
    if(!a || a.target === '_blank' || a.hasAttribute('download')) return;
    if(a.hostname !== location.hostname) return;
    var href = a.getAttribute('href');
    if(!href || href.charAt(0) === '#' || (a.pathname === location.pathname && a.hash)) return;
    if(a.closest('[data-cart-close],[data-no-bar]')) return;
    bar.classList.remove('done');
    void bar.offsetWidth;
    bar.classList.add('go');
  });
  window.addEventListener('pageshow', function(){ bar.classList.remove('go'); });

  /* ── 2. IMAGE SHIMMER OFF WHEN LOADED ───────────────── */
  function markLoaded(scope){
    (scope || document).querySelectorAll('.pcard-img img').forEach(function(img){
      var wrap = img.closest('.pcard-img');
      if(img.complete && img.naturalWidth) wrap.classList.add('is-loaded');
      else img.addEventListener('load', function(){ wrap.classList.add('is-loaded'); }, { once: true });
    });
  }
  markLoaded();

  /* ── 3. SCROLL REVEAL + STAMPS + COUNTERS ───────────── */
  var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function(entries){
    entries.forEach(function(en){
      if(!en.isIntersecting) return;
      var el = en.target;
      el.classList.add('sd-in');
      if(el.hasAttribute('data-count-to')) countUp(el);
      io.unobserve(el);
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' }) : null;

  function watch(scope){
    var s = scope || document;
    // sections below the first screen rise in; the hero never waits
    var secs = s.querySelectorAll('main > .shopify-section');
    secs.forEach(function(sec, i){
      if(i === 0 || sec.dataset.sdWatched) return;
      if(sec.querySelector('.hs, .pp, [data-no-reveal]')) return;
      var r = sec.getBoundingClientRect();
      if(r.top < window.innerHeight * 0.9) return;
      sec.dataset.sdWatched = '1';
      sec.classList.add('sd-rv');
      if(io) io.observe(sec); else sec.classList.add('sd-in');
    });
    s.querySelectorAll('.pcard, [data-count-to]').forEach(function(el){
      if(el.dataset.sdWatched) return;
      el.dataset.sdWatched = '1';
      if(io) io.observe(el); else { el.classList.add('sd-in'); if(el.hasAttribute('data-count-to')) countUp(el); }
    });
  }
  if(!RM) root.classList.add('sd-motion');
  watch();
  // anything still hidden after 4s (odd layouts, print) is shown
  setTimeout(function(){ document.querySelectorAll('.sd-rv:not(.sd-in)').forEach(function(el){ if(el.getBoundingClientRect().top < window.innerHeight) el.classList.add('sd-in'); }); }, 4000);

  function countUp(el){
    var to = parseFloat(el.getAttribute('data-count-to')) || 0;
    var suffix = el.getAttribute('data-suffix') || '';
    if(RM){ el.textContent = to.toLocaleString('en-US') + suffix; return; }
    var t0 = performance.now(), dur = 1500;
    (function step(t){
      var p = Math.min(1, (t - t0) / dur), e = 1 - Math.pow(1 - p, 3);
      el.textContent = Math.round(to * e).toLocaleString('en-US') + (p === 1 ? suffix : '');
      if(p < 1) requestAnimationFrame(step);
    })(t0);
  }

  /* ── 4. 3D TILT ON PRODUCT CARDS (mouse only) ───────── */
  if(FINE && !RM){
    document.addEventListener('pointermove', function(e){
      var card = e.target.closest && e.target.closest('.pcard');
      if(!card || card.closest('.sd-qv, .sd-saved')) return;
      var r = card.getBoundingClientRect();
      var x = (e.clientX - r.left) / r.width - 0.5, y = (e.clientY - r.top) / r.height - 0.5;
      card.style.setProperty('--rx', (-y * 7).toFixed(2) + 'deg');
      card.style.setProperty('--ry', (x * 9).toFixed(2) + 'deg');
      card.classList.add('sd-tilt');
    }, { passive: true });
    document.addEventListener('pointerout', function(e){
      var card = e.target.closest && e.target.closest('.pcard');
      if(card && !card.contains(e.relatedTarget)){ card.classList.remove('sd-tilt'); card.style.removeProperty('--rx'); card.style.removeProperty('--ry'); }
    }, { passive: true });
  }

  /* ── 5. FLY TO BAG + STICKER TOAST ──────────────────── */
  function bagIcon(){
    var list = document.querySelectorAll('[data-cart-toggle]');
    for(var i = 0; i < list.length; i++){ var r = list[i].getBoundingClientRect(); if(r.width && r.bottom > 0) return list[i]; }
    return null;
  }
  function sourceInfo(src){
    var info = { img: '', title: '' };
    if(!src) return info;
    if(src.nodeType !== 1){ return src; }
    var card = src.closest('.pcard, .sd-qv-card, .pp, .sd-saved-item');
    var im = card ? card.querySelector('.pcard-img img, .sd-qv-img img, .pp-slide img, img') : null;
    if(!im && document.querySelector('.pp-slide img')) im = document.querySelector('.pp-slide img');
    info.imgEl = im;
    info.img = im ? (im.currentSrc || im.src) : '';
    var nm = card ? card.querySelector('.pcard-name, .sd-qv-title, .pp-name, .sd-saved-name') : null;
    info.title = nm ? nm.textContent.trim() : '';
    return info;
  }
  M.fly = function(src, done){
    var info = sourceInfo(src);
    var bag = bagIcon();
    var from = info.imgEl || (src && src.nodeType === 1 ? src : null);
    if(RM || !bag || !from || !document.body.animate){ if(done) done(info); return; }
    var a = from.getBoundingClientRect(), b = bag.getBoundingClientRect();
    var size = Math.min(120, Math.max(56, a.width * 0.4));
    var f = document.createElement('div');
    f.className = 'sd-flyer';
    f.style.width = f.style.height = size + 'px';
    if(info.img) f.style.backgroundImage = 'url("' + info.img.replace(/"/g, '%22') + '")';
    document.body.appendChild(f);
    var sx = a.left + a.width / 2 - size / 2, sy = a.top + a.height / 2 - size / 2;
    var ex = b.left + b.width / 2 - size / 2, ey = b.top + b.height / 2 - size / 2;
    var mx = (sx + ex) / 2, my = Math.min(sy, ey) - 90;
    f.animate([
      { transform: 'translate(' + sx + 'px,' + sy + 'px) scale(1) rotate(0deg)', opacity: 1 },
      { transform: 'translate(' + mx + 'px,' + my + 'px) scale(.7) rotate(-12deg)', opacity: 1, offset: .55 },
      { transform: 'translate(' + ex + 'px,' + ey + 'px) scale(.18) rotate(8deg)', opacity: .6 }
    ], { duration: 720, easing: 'cubic-bezier(.45,0,.35,1)' }).onfinish = function(){
      f.remove();
      bag.classList.remove('sd-bump'); void bag.offsetWidth; bag.classList.add('sd-bump');
      if(done) done(info);
    };
  };

  var toastEl = null, toastT = null;
  M.toast = function(src){
    var info = sourceInfo(src);
    if(!toastEl){
      toastEl = document.createElement('div');
      toastEl.className = 'sd-toast';
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      document.body.appendChild(toastEl);
      toastEl.addEventListener('click', function(e){
        if(e.target.closest('[data-toast-bag]')){ hide(); var t = document.querySelector('[data-cart-toggle]'); if(t) t.click(); }
        if(e.target.closest('[data-toast-x]')) hide();
      });
    }
    function hide(){ toastEl.classList.remove('show'); }
    toastEl.innerHTML =
      '<span class="sd-toast-th">' + (info.img ? '<img src="' + esc(info.img) + '" alt="">' : '') + '</span>' +
      '<span class="sd-toast-tx"><b>Added to your bag</b>' + (info.title ? '<span>' + esc(info.title) + '</span>' : '') + '</span>' +
      '<button type="button" class="sd-toast-go" data-toast-bag>View bag</button>' +
      '<button type="button" class="sd-toast-x" data-toast-x aria-label="Close">&times;</button>';
    toastEl.classList.remove('show'); void toastEl.offsetWidth; toastEl.classList.add('show');
    clearTimeout(toastT); toastT = setTimeout(hide, 4200);
  };

  /* ── 6. SAVED ITEMS (hearts + drawer) ───────────────── */
  var SAVE_KEY = 'sd_saved';
  function saved(){ return ls(SAVE_KEY) || []; }
  function paintHearts(){
    var list = saved();
    document.querySelectorAll('[data-save]').forEach(function(b){
      var on = list.indexOf(b.getAttribute('data-save')) > -1;
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    document.querySelectorAll('.saved-count').forEach(function(c){
      c.textContent = list.length; c.hidden = !list.length;
    });
  }
  function toggleSave(handle, btn){
    var list = saved(), i = list.indexOf(handle);
    if(i > -1) list.splice(i, 1); else { list.unshift(handle); list = list.slice(0, 30); }
    ls(SAVE_KEY, list);
    paintHearts();
    if(btn && i === -1){ btn.classList.remove('sd-pop'); void btn.offsetWidth; btn.classList.add('sd-pop'); }
    if(savedPanel && savedPanel.classList.contains('open')) renderSaved();
  }

  var savedPanel = null, savedOv = null;
  function buildSaved(){
    savedOv = document.createElement('div');
    savedOv.className = 'sd-saved-ov';
    savedPanel = document.createElement('aside');
    savedPanel.className = 'sd-saved';
    savedPanel.setAttribute('aria-label', 'Saved items');
    savedPanel.innerHTML = '<div class="sd-saved-head"><h3>Saved</h3><button type="button" class="sd-saved-x" aria-label="Close saved items">&times;</button></div><div class="sd-saved-list"></div>';
    document.body.appendChild(savedOv);
    document.body.appendChild(savedPanel);
    savedOv.addEventListener('click', closeSaved);
    savedPanel.querySelector('.sd-saved-x').addEventListener('click', closeSaved);
    document.addEventListener('keydown', function(e){ if(e.key === 'Escape') closeSaved(); });
  }
  function openSaved(){
    if(!savedPanel) buildSaved();
    savedOv.classList.add('open'); savedPanel.classList.add('open');
    renderSaved();
    var x = savedPanel.querySelector('.sd-saved-x'); if(x) x.focus();
  }
  function closeSaved(){ if(savedPanel){ savedOv.classList.remove('open'); savedPanel.classList.remove('open'); } }
  function renderSaved(){
    var box = savedPanel.querySelector('.sd-saved-list');
    var list = saved();
    if(!list.length){
      box.innerHTML = '<p class="sd-saved-empty">Nothing saved yet. Tap the heart on any piece to keep it here.</p>';
      return;
    }
    box.innerHTML = '<p class="sd-saved-empty">Loading…</p>';
    Promise.all(list.map(productJS)).then(function(ps){
      ps = ps.filter(Boolean);
      if(!ps.length){ box.innerHTML = '<p class="sd-saved-empty">These pieces are no longer available.</p>'; return; }
      box.innerHTML = ps.map(function(p){
        var v = null;
        for(var i = 0; i < p.variants.length; i++){ if(p.variants[i].available){ v = p.variants[i]; break; } }
        var act = (v && p.variants.length === 1 && p.type !== 'Bundles')
          ? '<button type="button" class="sd-saved-add" data-quick-add="' + v.id + '">Add to bag</button>'
          : '<a class="sd-saved-add" href="' + esc(p.url) + '">' + (p.available ? 'Choose options' : 'Sold out') + '</a>';
        return '<div class="sd-saved-item">' +
          '<a href="' + esc(p.url) + '" class="sd-saved-img"><img src="' + esc(sized(p.featured_image, 200)) + '" alt="" loading="lazy"></a>' +
          '<div class="sd-saved-info"><a href="' + esc(p.url) + '" class="sd-saved-name">' + esc(p.title) + '</a>' +
          '<div class="sd-saved-price">' + money(p.price) + '</div>' + act + '</div>' +
          '<button type="button" class="sd-saved-rm" data-save="' + esc(p.handle) + '" aria-label="Remove ' + esc(p.title) + ' from saved">&times;</button>' +
        '</div>';
      }).join('');
    });
  }
  M.openSaved = openSaved;

  /* ── 7. QUICK VIEW ──────────────────────────────────── */
  var qv = null;
  function buildQV(){
    qv = document.createElement('div');
    qv.className = 'sd-qv';
    qv.setAttribute('role', 'dialog');
    qv.setAttribute('aria-modal', 'true');
    qv.setAttribute('aria-label', 'Quick view');
    qv.innerHTML = '<div class="sd-qv-bg" data-qv-close></div><div class="sd-qv-card"></div>';
    document.body.appendChild(qv);
    qv.addEventListener('click', function(e){ if(e.target.closest('[data-qv-close]')) closeQV(); });
    document.addEventListener('keydown', function(e){ if(e.key === 'Escape') closeQV(); });
  }
  function closeQV(){ if(qv){ qv.classList.remove('open'); document.documentElement.classList.remove('sd-lock'); } }
  function openQV(handle, opener){
    if(!qv) buildQV();
    var card = qv.querySelector('.sd-qv-card');
    card.innerHTML = '<div class="sd-qv-loading">Loading…</div>';
    qv.classList.add('open');
    document.documentElement.classList.add('sd-lock');
    productJS(handle).then(function(p){
      if(!p){ card.innerHTML = '<div class="sd-qv-loading">Could not load this piece. <a href="/products/' + esc(handle) + '">Open the page</a></div>'; return; }
      var isBundle = p.type === 'Bundles';
      var imgs = (p.images || []).slice(0, 6);
      var opts = (p.options || []).filter(function(o){ return !(o.name === 'Title' && o.values.length === 1 && o.values[0] === 'Default Title'); });
      var first = p.variants.filter(function(v){ return v.available; })[0] || p.variants[0];
      var sel = first ? first.options.slice() : [];
      card.innerHTML =
        '<button type="button" class="sd-qv-x" data-qv-close aria-label="Close quick view">&times;</button>' +
        '<div class="sd-qv-img">' + imgs.map(function(u, i){ return '<img src="' + esc(sized(u, 800)) + '" alt="' + esc(p.title) + (i ? ' ' + (i + 1) : '') + '"' + (i ? ' loading="lazy"' : '') + '>'; }).join('') + '</div>' +
        '<div class="sd-qv-info">' +
          '<div class="sd-qv-type">' + esc(p.type || '') + '</div>' +
          '<h2 class="sd-qv-title">' + esc(p.title) + '</h2>' +
          '<div class="sd-qv-price" data-qv-price>' + money(first ? first.price : p.price) + '</div>' +
          opts.map(function(o, oi){
            return '<label class="sd-qv-opt"><span>' + esc(o.name) + '</span><select data-qv-opt="' + oi + '">' +
              o.values.map(function(val){ return '<option' + (sel[oi] === val ? ' selected' : '') + '>' + esc(val) + '</option>'; }).join('') +
            '</select></label>';
          }).join('') +
          (isBundle
            ? '<a class="btn-r sd-qv-add" href="' + esc(p.url) + '">Build this bundle</a>'
            : '<button type="button" class="btn-r sd-qv-add" data-qv-add>' + (first && first.available ? 'Add to bag' : 'Sold out') + '</button>') +
          '<p class="sd-qv-cod">Cash on delivery. You pay when it arrives.</p>' +
          '<a class="sd-qv-more" href="' + esc(p.url) + '">See full details</a>' +
        '</div>';
      function current(){
        return p.variants.filter(function(v){ return v.options.every(function(x, i){ return opts[i] ? x === sel[i] : true; }); })[0];
      }
      card.querySelectorAll('[data-qv-opt]').forEach(function(s){
        s.addEventListener('change', function(){
          sel[+s.getAttribute('data-qv-opt')] = s.value;
          var v = current(), btn = card.querySelector('[data-qv-add]');
          card.querySelector('[data-qv-price]').textContent = money(v ? v.price : p.price);
          if(btn){ btn.disabled = !(v && v.available); btn.textContent = v ? (v.available ? 'Add to bag' : 'Sold out') : 'Unavailable'; }
        });
      });
      var add = card.querySelector('[data-qv-add]');
      if(add){
        add.disabled = !(first && first.available);
        add.addEventListener('click', function(){
          var v = current();
          if(!v || !v.available || !window.SD) return;
          add.disabled = true; add.textContent = 'Adding…';
          window.SD.add(v.id, 1, function(ok){
            add.disabled = false; add.textContent = 'Add to bag';
            if(!ok) return;
            var info = { img: imgs[0] ? sized(imgs[0], 300) : '', title: p.title, imgEl: card.querySelector('.sd-qv-img img') };
            M.fly(info.imgEl, function(){ closeQV(); M.toast(info); });
          });
        });
      }
      var x = card.querySelector('.sd-qv-x'); if(x) x.focus();
    });
    qv._opener = opener;
  }

  /* ── 8. FLOATING WHATSAPP ───────────────────────────── */
  if(CFG.wa){
    var msg = CFG.product
      ? 'Hi 77, I have a question about ' + CFG.product.title + ' (' + CFG.product.url + ')'
      : 'Hi 77, I have a question';
    var wa = document.createElement('a');
    wa.className = 'sd-wa';
    wa.href = 'https://wa.me/' + encodeURIComponent(CFG.wa) + '?text=' + encodeURIComponent(msg);
    wa.target = '_blank';
    wa.rel = 'noopener noreferrer';
    wa.setAttribute('aria-label', 'Chat with us on WhatsApp');
    wa.innerHTML = '<svg viewBox="0 0 24 24" width="26" height="26" aria-hidden="true"><path fill="currentColor" d="M17.6 6.32A8.86 8.86 0 0 0 12.05 4a8.94 8.94 0 0 0-7.69 13.42L3 21l3.69-1.32a8.9 8.9 0 0 0 4.36 1.13h.01a8.94 8.94 0 0 0 6.54-15.49ZM12.06 19.1a7.4 7.4 0 0 1-3.78-1.04l-.27-.16-2.81 1 .94-2.73-.18-.28a7.43 7.43 0 1 1 13.78-4 7.43 7.43 0 0 1-7.68 7.21Zm4.07-5.56c-.22-.11-1.3-.64-1.5-.72-.2-.07-.35-.11-.5.11-.15.22-.57.72-.7.86-.13.15-.26.16-.48.05-.22-.11-1.13-.42-2.15-1.32-.8-.7-1.33-1.57-1.49-1.84-.15-.26-.02-.4.11-.52.11-.11.26-.29.39-.43.13-.15.17-.26.26-.43.09-.18.04-.33-.04-.44-.07-.11-.61-1.48-.84-2.03-.22-.53-.45-.46-.62-.47-.16-.01-.35-.01-.54-.01-.18 0-.48.07-.74.33-.26.26-1 1-1 2.42s1.02 2.81 1.16 3c.15.18 2.02 3.08 4.9 4.2 2.87 1.12 2.87.75 3.39.7.51-.04 1.65-.67 1.89-1.32.24-.65.24-1.2.17-1.32-.07-.11-.22-.18-.44-.29Z"/></svg><span class="sd-wa-tip">' + (CFG.product ? 'Ask about this piece' : 'Questions? WhatsApp us') + '</span>';
    document.body.appendChild(wa);
    // lift it above the sticky add-to-bag bar when that bar is showing
    var sticky = document.getElementById('stickyAtc');
    if(sticky && 'MutationObserver' in window){
      new MutationObserver(function(){ wa.classList.toggle('lift', sticky.classList.contains('show')); }).observe(sticky, { attributes: true, attributeFilter: ['class'] });
    }
  }

  /* ── 9. CLICK DELEGATION ────────────────────────────── */
  document.addEventListener('click', function(e){
    var s = e.target.closest('[data-save]');
    if(s){ e.preventDefault(); e.stopPropagation(); toggleSave(s.getAttribute('data-save'), s); return; }
    if(e.target.closest('[data-saved-open]')){ e.preventDefault(); openSaved(); return; }
    var q = e.target.closest('[data-qv]');
    if(q){ e.preventDefault(); openQV(q.getAttribute('data-qv'), q); return; }
  }, true);

  paintHearts();
  window.addEventListener('storage', function(e){ if(e.key === SAVE_KEY) paintHearts(); });

  // sections added in the theme editor
  document.addEventListener('shopify:section:load', function(e){ watch(e.target); markLoaded(e.target); paintHearts(); });
})();
